/** Checks whether user input matches the required confirmation text. Trims, exact (case-sensitive). */
export function matchesConfirmText(input: string, required: string): boolean {
  return input.trim() === required;
}
